export const SET_LOADING_DATA = '@promotion/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@promotion/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@promotion/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@promotion/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@promotion/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@promotion/GET_BY_ID_SUCCESS';

export const GET_BY_ID_REQUEST_IMPORT = '@promotion/GET_BY_ID_REQUEST_IMPORT';

export const GET_FILTER_PRODUCT_REQUEST = '@promotion/GET_FILTER_PRODUCT_REQUEST';
export const GET_FILTER_PRODUCT_SUCCESS = '@promotion/GET_FILTER_PRODUCT_SUCCESS';

export const GET_FILTER_CLIENT_REQUEST = '@promotion/GET_FILTER_CLIENT_REQUEST';
export const GET_FILTER_CLIENT_SUCCESS = '@promotion/GET_FILTER_CLIENT_SUCCESS';

export const GET_FILTER_REWARDS_REQUEST = '@promotion/GET_FILTER_REWARDS_REQUEST';
export const GET_FILTER_REWARDS_SUCCESS = '@promotion/GET_FILTER_REWARDS_SUCCESS';

export const SAVE_REQUEST = '@promotion/SAVE_REQUEST';
export const SAVE_SUCCESS = '@promotion/SAVE_SUCCESS';

export const SAVE_IMPORT_REQUEST = '@promotion/SAVE_IMPORT_REQUEST';

export const DELETE_ITEM = '@promotion/DELETE_ITEM';
export const EDIT_ITEM = '@promotion/EDIT_ITEM';
export const EDIT_IMPORTED_ITEM = '@promotion/EDIT_IMPORTED_ITEM';

export const SEARCH = '@promotion/SEARCH';

export const SET_PAGE = '@promotion/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@promotion/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@promotion/SET_ORDER';
export const SET_ORDERBY = '@promotion/SET_ORDEBY';
